<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список контента</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить контент</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="form-body">
            <div class="mb-4" v-if="client_id === 0 && clients.length > 0">
                <div class="form-label">Клиент <span class="color-red">*</span></div>
                <v-select
                    v-model="picked_client"
                    :items="clients"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>

            <div class="mb-4">
                <div class="form-label">Бренд <span class="color-red">*</span></div>
                <v-select
                    :disabled="formData.client_id ? false : true"
                    v-model="formData.brand_id"
                    :items="brands"
                    @update:modelValue="onChangeBrand"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    clearable
                    density="compact">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>

            <div class="mb-4">
                <label for="exampleFormControlInput1" class="form-label">Название <span class="color-red">*</span></label>
                <input type="text" class="form-control" placeholder="" v-model="formData.name">
            </div>

            <!-- <div class="mb-4">
                <div class="form-label">Выберите тип контента</div>
                <v-select
                    class="no-searchable"
                    v-model="formData.type"
                    :reduce="name => name.id" label="name"
                    :options="[{id: 1, name: 'Изображение'},{id: 2, name: 'Видео'}]"
                    :deselectFromDropdown="false"
                    :clearable="false"
                    :searchable="false"
                >
                </v-select>
            </div> -->

            <div class="mb-4">
                <file-upload-element @fileUpload="fileUpload" :multiple_property="true"></file-upload-element>
            </div>

            <div class="mb-4">
                <div class="form-label">Плейлист</div>
                <v-select
                    :disabled="formData.client_id && formData.brand_id ? false : true"
                    v-model="formData.playlist_id"
                    :items="playlists"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>

            <div class="form-check mb-4">
                <label class="form-check-label" for="is_statistics_enabled">
                    Сбор статистики показов
                </label>
                <input class="form-check-input" type="checkbox" value="" id="is_statistics_enabled" v-model="formData.is_statistics_enabled">
            </div>

            <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
                <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createContent"/>
                <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
            </div>

        </div>

        <Alert />

        <Transition name="fade">
            <v-progress-circular v-if="loading"
                :model-value="progress"
                :rotate="360"
                :size="65"
                :width="8"
            >
                <template v-slot:default> {{ progress }} % </template>
            </v-progress-circular>
        </Transition>
    </div>
</template>

<script>

import Content from "../../../../models/Content";
import FileUploadElement from "../../../../elements/FileUploadElement.vue";
import Playlist from '../../../../models/Playlist';
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";

export default {
    name: 'ContentCreateComponent',
    components: { FileUploadElement, Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_client_search: String,
        route_brand_search: String,
        route_create: String,
        route_list_playlists: String,
        domain: String,
        client_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            playlist: new Playlist({
                route_list: this.route_list_playlists,
            }),
            content: new Content({
                route_create: this.route_create,
                route_brand_search: this.route_brand_search,
                route_client_search: this.route_client_search
            }),
            clients: [],
            playlists: [],
            picked_client: undefined,
            brands: [],
            filePick: '',
            formData: {
                client_id: 0,
                brand_id: null,
                playlist_id: null,
                name: '',
                type: 1,
                file: [],
                duration: '00:00:05',
                is_statistics_enabled: false
            },
            loading: false,
            progress: 0
        };
    },
    watch: {
        picked_client: async function () {
            this.formData.client_id = this.picked_client;
            this.formData.brand_id = null;
            await this.searchBrands();
            if (this.formData.client_id && this.formData.brand_id) await this.loadPlaylists();
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createContent: async function () {
            if (this.formData.client_id === 0) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }
            if (!this.formData.brand_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите бренд!' });
                this.toggleLoading();
                return;
            }
            if (this.formData.name === '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите название!' });
                this.toggleLoading();
                return;
            }
            if (!this.formData.file.length) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите файл!' });
                this.toggleLoading();
                return;
            }

            this.loading = true;

            let formData = new FormData();
            formData.append('client_id', this.formData.client_id);
            formData.append('brand_id', this.formData.brand_id);
            formData.append('playlist_id', this.formData.playlist_id);
            formData.append('name', this.formData.name);
            formData.append('type', this.formData.type);
            formData.append('is_statistics_enabled', this.formData.is_statistics_enabled);

            this.formData.file.forEach(element => {
                formData.append("file[]", element);
            });

            let result = await this.content.create(formData);

            this.progress = 100;
            setTimeout(() => {
                this.loading = false;

                if (result) {
                    window.location.href = this.route_back;
                } else {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: window.lastResponse.data.message });
                    this.toggleLoading();
                    // this.formData.file = [];
                }
            }, 200);
        },
        searchClients: async function () {
            let clients = await this.content.clients();
            this.clients = clients.items;
        },
        searchBrands: async function () {
            let brands = await this.content.brands({
                client_id: this.picked_client
            });
            this.brands = brands.items;
        },
        fileUpload: function (e) {
            if (e) {
                this.formData.file = [];
                this.formData.file.push(e);
            }

            if (!e) {
                this.formData.file = [];
            }
        },
        loadPlaylists: async function () {
            let response = await this.playlist.loadTable(
                1,
                50,
                '',
                this.formData.brand_id
            );

            for (let i = 0; i < response.tbody.length; i++) {
                this.playlists[i] = {
                    id: response.tbody[i].id,
                    name: response.tbody[i].tbody.name
                }
            }
        },
        onChangeBrand: async function (brand_id) {
            this.formData.playlist_id = null;
            this.playlists = [];
            this.formData.brand_id = brand_id;
            await this.loadPlaylists();
        },
        interceptResponse() {
            window.lastResponse = null;

            axios.interceptors.response.use(response => {
                window.lastResponse = response;
                return response;
            }, error => {
                window.lastResponse = error.response;
                return Promise.reject(error);
            });
        }
    },
    mounted() {
        this.searchClients();
        this.searchBrands();
        this.interceptResponse();
    }
};
</script>

<style scoped>
    .form-check {
        display: block !important;
    }
</style>
